import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const TrashCanIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.9375 6.75V18.625C17.9375 19.3154 17.3779 19.875 16.6875 19.875H7.3125C6.62214 19.875 6.0625 19.3154 6.0625 18.625V6.75M14.8125 6.75V4.25C14.8125 3.55964 14.2529 3 13.5625 3H10.4375C9.74714 3 9.1875 3.55964 9.1875 4.25V6.75M3.875 6.75H20.125"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <path
        d="M9.87 10.5L9.86999 16.5"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <path
        d="M14.12 10.5L14.12 16.5"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};
